'use strict';
module.exports = require('./PanelMenu.vue');